"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pandeTotalizeReducer = exports.pandeTotalizeActions = exports.TYPES = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'pandeTotalize';

// アクションタイプ
const TYPES = exports.TYPES = {
  // 共有条件適用
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion',
  // 集計条件変更
  CHANGE_CONDITION: PREFIX + 'ChangeCondtion',
  // 集計結果を設定
  SET_RESULT: PREFIX + 'SetResult',
  // 全状態を初期状態にする
  CLEAR: PREFIX + 'Clear'
};

// 初期状態
const INIT_STATE = {
  conditions: {
    kaishaCd: '',
    soshikiCd: '',
    firstReportDtStart: '',
    firstReportDtEnd: '',
    kensaRstDtStart: '',
    kensaRstDtEnd: '',
    kaishaSoshikiLabel: '',
    pandeAttribute: _CodeConsts.CODE.PANDE_TOT_ATTRIBUTE.CODE_1,
    includeSuspicious: true
  },
  fixedConditions: {},
  result: []
};
const pandeTotalizeActions = exports.pandeTotalizeActions = (0, _reduxActions.createActions)({
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      shareCondition: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_RESULT]: function () {
    return {
      resultData: arguments.length <= 0 ? undefined : arguments[0],
      fixedConditions: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
}, TYPES.CLEAR);
const pandeTotalizeReducer = exports.pandeTotalizeReducer = (0, _reduxActions.handleActions)({
  [TYPES.APPLY_SHARE_CONDITION]: (state, action) => {
    const _action$payload$share = action.payload.shareCondition,
      rest = _extends({}, (_objectDestructuringEmpty(_action$payload$share), _action$payload$share));
    return _objectSpread(_objectSpread({}, state), {}, {
      conditions: _objectSpread(_objectSpread({}, state.conditions), rest)
    });
  },
  [TYPES.CHANGE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    conditions: _objectSpread(_objectSpread({}, state.conditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SET_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    result: action.payload.resultData,
    fixedConditions: action.payload.fixedConditions
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);